
/**
 * @ignore
 */
export const DEFAULT_VECTOR_CAPACITY = 1024;

/**
 * @ignore
 */
export const DEFAULT_VECTOR_ALLOC_STEP = 255;

